export let expiredSearchFolder_tooltip = "PHDRNb";
export let expiredSearchFolder_dialogTitle = "UTU5he";
export let expiredSearchFolder_dialogBody = "QM1Ofe";
export let expiredSearchFolder_reactivateButton = "INHmOe";
export let expiredSearchFolder_deleteButton = "hNE1j";
export let crossAccountMoveBlockedTooltip = "X2Iajb";
export default {expiredSearchFolder_tooltip,expiredSearchFolder_dialogTitle,expiredSearchFolder_dialogBody,expiredSearchFolder_reactivateButton,expiredSearchFolder_deleteButton,crossAccountMoveBlockedTooltip};